import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from "@rails/request.js"

export default class extends Controller {
  static values = {
    handle: String,
    resourceName: String,
  }

  connect() {
    this.dragged = null
    this.placeholder = null
    this.offsetY = 0

    this.items().forEach((item) => {
      const handle = item.querySelector(this.handleValue)
      if (!handle) return
      handle.style.cursor = 'grab'
      handle.addEventListener('pointerdown', this.onPointerDown)
    })
  }

  disconnect() {
    this.items().forEach((item) => {
      const handle = item.querySelector(this.handleValue)
      if (handle) handle.removeEventListener('pointerdown', this.onPointerDown)
    })
  }

  items() {
    return Array.from(this.element.querySelectorAll(':scope > .sorting-tab'))
  }

  onPointerDown = (e) => {
    e.preventDefault()
    const item = e.target.closest('.sorting-tab')
    if (!item) return

    this.dragged = item
    const rect = item.getBoundingClientRect()
    this.offsetY = e.clientY - rect.top

    this.placeholder = document.createElement('div')
    this.placeholder.style.height = `${rect.height}px`
    this.placeholder.style.border = '2px dashed #ccc'
    this.placeholder.style.borderRadius = '4px'
    this.placeholder.style.marginBottom = '0.5rem'
    item.parentNode.insertBefore(this.placeholder, item)

    item.style.position = 'fixed'
    item.style.zIndex = '9999'
    item.style.width = `${rect.width}px`
    item.style.left = `${rect.left}px`
    item.style.top = `${rect.top}px`
    item.style.opacity = '0.9'
    item.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'
    item.style.pointerEvents = 'none'
    item.style.transition = 'none'
    item.style.background = '#fff'

    document.addEventListener('pointermove', this.onPointerMove)
    document.addEventListener('pointerup', this.onPointerUp)
  }

  onPointerMove = (e) => {
    if (!this.dragged) return

    this.dragged.style.top = `${e.clientY - this.offsetY}px`

    const siblings = this.items().filter(i => i !== this.dragged)
    const target = this.findClosest(e.clientY, siblings)

    if (target) {
      const rect = target.getBoundingClientRect()
      const mid = rect.top + rect.height / 2
      if (e.clientY < mid) {
        target.before(this.placeholder)
      } else {
        target.after(this.placeholder)
      }
    }
  }

  onPointerUp = async () => {
    document.removeEventListener('pointermove', this.onPointerMove)
    document.removeEventListener('pointerup', this.onPointerUp)

    if (!this.dragged || !this.placeholder) return

    this.placeholder.replaceWith(this.dragged)
    this.dragged.style.position = ''
    this.dragged.style.zIndex = ''
    this.dragged.style.width = ''
    this.dragged.style.left = ''
    this.dragged.style.top = ''
    this.dragged.style.opacity = ''
    this.dragged.style.boxShadow = ''
    this.dragged.style.pointerEvents = ''
    this.dragged.style.transition = ''
    this.dragged.style.background = ''

    await this.persistPosition(this.dragged)

    this.dragged = null
    this.placeholder = null
  }

  findClosest(y, items) {
    let closest = null
    let closestDist = Infinity

    items.forEach((item) => {
      const rect = item.getBoundingClientRect()
      const mid = rect.top + rect.height / 2
      const dist = Math.abs(y - mid)
      if (dist < closestDist) {
        closestDist = dist
        closest = item
      }
    })

    return closest
  }

  async persistPosition(item) {
    const url = item.dataset.sortableUpdateUrl
    if (!url) return

    const newIndex = this.items().indexOf(item)
    const param = this.resourceNameValue
      ? `${this.resourceNameValue}[position]`
      : 'position'

    const data = new FormData()
    data.append(param, newIndex + 1)

    await new FetchRequest('patch', url, {
      body: data,
      responseKind: 'html',
    }).perform()
  }
}
